"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CODE_CHAR_TEMPLATE = 'abcdefghijklmnopqrstuvwxyz1234567890';
exports.PROFILE_CODE_LENGTH = 6;
exports.CUSTOMER_TYPE_CODE_LENGTH = 4;
exports.generateCode = ({ length = 10, affix, prefix, template }) => {
    let code = '';
    const characters = template || exports.CODE_CHAR_TEMPLATE;
    for (let i = 0; i < length; i += 1) {
        code += characters.charAt(Math.floor(Math.random() * characters.length));
    }
    if (affix) {
        code = `${affix.toLowerCase()}-${code}`;
    }
    if (prefix) {
        code = `${code}-${prefix.toLowerCase()}`;
    }
    return code;
};
//# sourceMappingURL=generateCode.js.map